enum ButtonTheme {
  NORMAL = 'normal',
  INVERTED = 'inverted',
  QUESTION = 'question',
  TEXT = 'text',
}

export default ButtonTheme;
